<script setup>
import { ShoppingCartIcon } from '@heroicons/vue/outline'
import { usePage } from '@inertiajs/inertia-vue3'
import { computed, ref, onMounted } from "vue";
import ShoppingCartPanel from "./ShoppingCartPanel";
import emitter from 'tiny-emitter/instance'
import Cart from "../../Cart";

const themeColor = computed(() => usePage().props.value.theme_color);
let openShoppingCartPanel = ref(false);
let shoppingCartCount = ref(0);

function updateCart(){
  const cart = new Cart();
  shoppingCartCount.value = cart.count;
}

onMounted(() => {
  updateCart()
})

emitter.on('updateCart', function(){
  openShoppingCartPanel.value = true;
  updateCart()
})

defineProps({
  pages: Object
})

</script>
<template>
  <button @click="openShoppingCartPanel = true" class="group -m-2 p-2 flex items-center">
    <ShoppingCartIcon class="flex-shrink-0 h-6 w-6 text-white group-hover:text-gray-300" aria-hidden="true" />
    <span class="ml-2 text-sm font-medium text-white group-hover:text-gray-300">{{ shoppingCartCount }}</span>
    <span class="sr-only">items in cart, view bag</span>
  </button>
  <ShoppingCartPanel v-model="openShoppingCartPanel" />
</template>
